import { render, staticRenderFns } from "./iousAuthorize.vue?vue&type=template&id=2ca13592&scoped=true"
import script from "./iousAuthorize.vue?vue&type=script&lang=ts"
export * from "./iousAuthorize.vue?vue&type=script&lang=ts"
import style0 from "./iousAuthorize.vue?vue&type=style&index=0&id=2ca13592&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca13592",
  null
  
)

export default component.exports